import { BaseSlide } from '../../../../../models/slides/BaseSlide';
import { CustomSlide } from '../../../../../models/slides/CustomSlide';

export const getCustomSlide = (slide: BaseSlide) => {
  const customSlide = slide as CustomSlide;
  const updatedSlide = {
    image: customSlide.image || {
      alt: '',
      url: '',
    },
    type: 'CUSTOM',
    content: customSlide.content,
  };

  return updatedSlide as CustomSlide;
};
